import { useContext } from 'react'
import styled from 'styled-components'

import { GameContext } from '../App'
import { StatusBar } from '../StageScreen'
import { Column }  from '../StageScreen/StageScreen'
import { RESOURCE } from '../game/constants'

const CenteredText = styled.p`
    text-align: center;
`

const PlayAgainButton = styled.button`
    display: block;
    width: 240px;
    font-size: 18px;
    text-transform: capitalize;
    text-align: center;
`

const CenteredColumn = styled(Column)`
    justify-content: space-between;
    align-items: center;
`

function EndScreen() {
    const { gameState, dispatch } = useContext(GameContext)

    let endText
    if( gameState.isOver ) {
        if(gameState.resources.get(RESOURCE.HEALTH).amount <= 0) {
            endText = 'Too many injuries have broken your poor body. \n You collapse and sleep for eternity.'
        } else if(gameState.resources.get(RESOURCE.SANITY).amount <= 0) {
            endText = 'Travelling back and forth in time has brought you to the abyss of madness. \n You cannot trust even your own thoughts anymore.'
        } else if(gameState.resources.get(RESOURCE.SUPPLIES).amount <= 0) {
            endText = 'Without any supply left, you will not get far before falling down from dehydratation or under-nourrishment.'
        } else if(gameState.resources.get(RESOURCE.FAME).amount <= 0) {
            endText = 'You\'ve become so infamous that you are not welcome in ANY time period ever.'
        }
        endText += `\nProgress: ${26 - gameState.deck.length} / 26`
    } else {
        endText = 'You have made it, the time continuum is fixed... for now.'
    }

    return (
        <CenteredColumn>
            <StatusBar />
            <CenteredText>{endText}</CenteredText>
            <PlayAgainButton onClick={() => dispatch({ type: 'LOAD_GAME' })}>Play Again</PlayAgainButton>
        </CenteredColumn>
    )
}

export default EndScreen